<template>
    <button
        type="button"
        :class="isLoading ? btnLoadingClass : btnClass"
        :disabled="isLoading || disabled"
        @click="handleClick"
    >
        <template v-if="isLoading">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ loadingTitle }}
        </template>
        <template v-else>
            {{ title }}
        </template>
    </button>
</template>

<script>
export default {
    emits: ['click'],
    props: {
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        loadingTitle: {
            type: String,
            required: false,
            default: 'Подождите...',
        },
        title: {
            type: String,
            required: true,
        },
        btnLoadingClass: {
            type: String,
            required: false,
            default: 'btn btn-primary disabled',
        },
        btnClass: {
            type: String,
            required: false,
            default: 'btn btn-primary',
        },
    },
    methods: {
        handleClick() {
            if (this.isLoading || this.disabled) {
                return;
            }
            this.$emit('click');
        },
    },
};
</script>
